/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { BtnIconArrow } from "../../icons/BtnIconArrow";
import "./style.css";

export const IdDiamondDown = ({
  className,
  rectangleClassName,
  btnIconArrowColor = "black",
}) => {
  return (
    <div className={`id-diamond-down ${className}`}>
      <div className="overlap-group-2">
        <div className={`rectangle-2 ${rectangleClassName}`} />

        <BtnIconArrow className="btn-icon-arrow" color={btnIconArrowColor} />
      </div>
    </div>
  );
};

IdDiamondDown.propTypes = {
  btnIconArrowColor: PropTypes.string,
};
